module.exports = __webpack_public_path__ + "images/icons_v2/location-empty-outlined-4e98612b.svg";